import zenvia from './zenvia/index';

export default {
  namespaced: true,
  zenvia,
};



// WEBPACK FOOTER //
// ./src/store/modules/integrations/index.js